// cspell:disable
import AAA from "./aaa-cooper.png?url";
import ABF from "./abf.png?url";
import Averitt from "./averitt.png?url";
import CentralTransport from "./central-transport.png?url";
import CrossCountryFreight from "./cross-country-freight.png?url";
import DaylightTransport from "./daylight-transport.png?url";
import DaytonFreight from "./dayton-freight.png?url";
import Dohrn from "./dohrn.png?url";
import Dugan from "./dugan.png?url";
import Estes from "./estes.png?url";
import FedexFreight from "./fedex-freight.png?url";
import ForwardAir from "./forward-air.png?url";
import Moran from "./moran.png?url";
import NMTransfer from "./nm-transfer.png?url";
import OakHarbor from "./oak-harbor.png?url";
import OldDominion from "./old-dominion.png?url";
import PittOhio from "./pitt-ohio.png?url";
import RLCarriers from "./rl-carriers.png?url";
import RoadrunnerFreight from "./roadrunner-freight.png?url";
import SAIA from "./saia.png?url";
import SouthwesternMotorTransport from "./smt.png?url";
import SoutheasternFreight from "./southeastern-freight.png?url";
import TForceFreight from "./tforce-freight.png?url";
import USRoadFreight from "./us-road-freight.png?url";
import Vocar from "./vocar.png?url";
import WarpTechnology from "./warp-technology.png?url";
import XPO from "./xpo.png?url";

export function getFreightLogoUrl(freightScac: string): string {
  switch (freightScac) {
    case "FXNL":
    case "FXFE": {
      return FedexFreight;
    }
    case "ABFS": {
      return ABF;
    }
    case "CCYQ": {
      return CrossCountryFreight;
    }
    case "CNWY": {
      return XPO;
    }
    case "UPGF": {
      return TForceFreight;
    }
    case "USRD": {
      return USRoadFreight;
    }
    case "FWRA": {
      return ForwardAir;
    }
    case "ODFL": {
      return OldDominion;
    }
    case "RLCA": {
      return RLCarriers;
    }
    case "AACT": {
      return AAA;
    }
    case "RDFS": {
      return RoadrunnerFreight;
    }
    case "EXLA": {
      return Estes;
    }
    case "SAIA": {
      return SAIA;
    }
    case "WTCH": {
      return WarpTechnology;
    }
    case "CTII": {
      return CentralTransport;
    }
    case "OAKH": {
      return OakHarbor;
    }
    case "VCTS": {
      return Vocar;
    }
    case "SMTL": {
      return SouthwesternMotorTransport;
    }
    case "DYLT": {
      return DaylightTransport;
    }
    case "SEFL": {
      return SoutheasternFreight;
    }
    case "DUBL": {
      return Dugan;
    }
    case "AVRT": {
      return Averitt;
    }
    case "PITD": {
      return PittOhio;
    }
    case "MTJG": {
      return Moran;
    }
    case "NMTF": {
      return NMTransfer;
    }
    case "DHRN": {
      return Dohrn;
    }
    case "DAFG": {
      return DaytonFreight;
    }
    // No default
  }
  return "";
}
